<template>
    <div class="utlz-product-block utlz-reset">
        <transition-group name="fade" tag="div" class="list-items-wrapper utlz-row">
            <utlz-product-list-item
              v-for="product in products"
              :key="product.id"
              :product="product"
              :blockSize="config.ItemSize"
              class="product-list-item">
            </utlz-product-list-item>
          </transition-group>
    </div>
</template>
<script>
import ProductListItem from 'src/components/webshop/products/product-list-item/ProductListItem.vue';
import { Product } from 'src/models/product.model';
import { getProductPrice } from 'src/services/product-service';
import axios from 'axios';

export default {
  computed: {
    config () {
      return this.$root.$data.config;
    },
    productCodes () {
      return this.config.ProductCodes;
    },
    productInformationUrl () {
      const endpoint = window.vue.globalData.endpoints.productInformation;
      const client = this.config.ClientCode;
      const language = this.config.Language;

      return `${endpoint}/${client}?language=${language}`;
    }
  },
  components: {
    'utlz-product-list-item': ProductListItem
  },
  data () {
    return {
      products: []
    }
  },
  methods: {
    getProductInformation () {
      axios.post(this.productInformationUrl, this.productCodes)
        .then(res => {
          const products = res.data.map(product => new Product(product));
          this.products = products;
          if (this.config.ShowStock) {
            this.getProductStock();
          } else {
            products.forEach(product => { product.setStock({ stockTotal: 0 }); })
          }

          if (this.config.ShowPrices) {
            getProductPrice(products);
          }

          if (this.config.ShowFavorites) {
            this.getCustomerLists();
          }
        });
    },
    getProductStock () {
      const url = window.vue.globalData.endpoints.productStockUrl
      this.products.forEach(productInitial => {
        axios.post(url, { 'productCode': productInitial.id })
          .then(res => {
            productInitial.setStock(res.data.d);
            // let index = this.products.findIndex(product => product.id === productWithStock.id);
            // state.products[index] = productWithStock;
          });
      });
    },
    getCustomerLists () {
      const endpoint = `${window.vue.globalData.endpoints.customerList}/GetProductLists?debtorId=${window.vue.globalData.userInformation.customerId}`;
      axios.post(endpoint, this.products.map(prod => prod.id))
        .then(res => {
          Object.keys(res.data).forEach(prodCode => {
            let filteredProduct = this.products[this.products.findIndex(product => product.id === prodCode)];
            if (filteredProduct !== undefined) {
              filteredProduct.setCustomerLists(res.data[prodCode]);
            }
          });
        });
    }
  },
  created () {
    this.getProductInformation();
  }
}
</script>
